// A product's unit of measure (kg, bottle, each…). Returns '' for values that
// aren't real units — blank, or a bare number like "10" — so callers can omit
// them instead of rendering "2 10 × BWP 90.00". Guards against unit fields that
// were mis-entered as quantities/pack sizes.
export function unitLabel(unit) {
  const u = (unit == null ? '' : String(unit)).trim();
  if (!u) return '';
  if (/^\d+(\.\d+)?$/.test(u)) return '';
  return u;
}
